import type { ReactNode } from 'react'
import { cn } from '../../lib/utils'

interface Tab<T extends string> {
  key: T
  label: string
}

interface TabsProps<T extends string> {
  tabs: Tab<T>[]
  value: T
  onChange: (value: T) => void
  size?: 'default' | 'sm'
  className?: string
  renderTab?: (tab: Tab<T>, isActive: boolean) => ReactNode
  /** @deprecated pill is the only variant — this prop is ignored */
  variant?: string
}

export const Tabs = <T extends string>({ tabs, value, onChange, size = 'default', className, renderTab }: TabsProps<T>) => {
  const isSmall = size === 'sm'

  return (
    <div className={cn('flex gap-1 bg-gray-100 rounded-lg p-1', isSmall && 'gap-0.5 p-0.5', className)}>
      {tabs.map(tab => {
        const isActive = value === tab.key
        return (
          <button
            key={tab.key}
            onClick={() => onChange(tab.key)}
            className={cn(
              'inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-md transition-colors cursor-pointer',
              isSmall && 'px-2 py-1 text-[10px]',
              isActive
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-500 hover:text-gray-700'
            )}
          >
            {tab.label}
            {renderTab?.(tab, isActive)}
          </button>
        )
      })}
    </div>
  )
}
